/* Smooth scrolling */
(function () {
    var lenis = new Lenis({
        autoRaf: true,
        anchors: true
    });
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Table of contents */
(function () {
    var toc = document.querySelector('.walrus-toc__list');
    if (!toc) return;

    var headings = document.querySelectorAll('.gh-content h2');

    if (!headings.length) {
        document.querySelector('.walrus-toc').style.display = 'none';
        return;
    }

    headings.forEach(function (heading) {
        if (!heading.id) {
            heading.id = heading.textContent
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-|-$/g, '');
        }

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        li.appendChild(a);
        toc.appendChild(li);
    });
})();

/* FAQ accordion with smooth animation */
(function () {
    const faqBlocks = document.querySelectorAll('.kg-faq-block');
    if (!faqBlocks.length) return;

    faqBlocks.forEach(function (block) {
        block.querySelectorAll('.kg-faq-item').forEach(function (details) {
            const summary = details.querySelector('.kg-faq-question');
            const answerEl = details.querySelector('.kg-faq-answer');
            if (!summary || !answerEl) return;

            const id = 'faq-' + Math.random().toString(36).slice(2, 9);
            answerEl.id = id;
            summary.setAttribute('aria-controls', id);
            summary.setAttribute('aria-expanded', 'false');

            summary.addEventListener('click', function (e) {
                e.preventDefault();

                if (details.classList.contains('is-open')) {
                    // Closing: remove is-open so CSS collapses, then clear open after transition
                    details.classList.remove('is-open');
                    details.classList.add('is-closing');
                    summary.setAttribute('aria-expanded', 'false');
                    answerEl.addEventListener('transitionend', function () {
                        details.open = false;
                        details.classList.remove('is-closing');
                    }, { once: true });
                } else {
                    // Opening: set open first (makes element visible at 0fr height),
                    // then add is-open on next frame so the transition has a valid start state
                    details.open = true;
                    requestAnimationFrame(function () {
                        details.classList.add('is-open');
                        summary.setAttribute('aria-expanded', 'true');
                    });
                }
            });
        });
    });
})();